import { NavLink } from 'react-router-dom';
import { colors, fonts, spacing } from '../theme';

const navStyle = {
  display: 'flex',
  gap: spacing.sm,
  flexWrap: 'wrap',
  marginBottom: spacing.xl,
  padding: spacing.sm,
  backgroundColor: colors.white,
  borderRadius: '12px',
  border: `1px solid ${colors.gray200}`,
  boxShadow: '0px 2px 8px 0px rgba(0, 99, 160, 0.06)',
};

const linkBase = {
  fontFamily: fonts.heading,
  fontSize: '0.9rem',
  fontWeight: 500,
  textDecoration: 'none',
  padding: `${spacing.sm} ${spacing.md}`,
  borderRadius: '999px',
  color: colors.midGray,
  transition: 'all 0.15s ease',
};

const LINKS = [
  { to: '/', label: 'Home', end: true },
  { to: '/documents', label: 'Documents' },
  { to: '/company', label: 'Company' },
  { to: '/billing', label: 'Billing' },
  { to: '/request-services', label: 'Request Services' },
];

function PortalNav() {
  return (
    <nav style={navStyle} aria-label="Portal sections">
      {LINKS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          style={({ isActive }) => ({
            ...linkBase,
            backgroundColor: isActive ? colors.blue : 'transparent',
            color: isActive ? colors.white : colors.midGray,
          })}
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}

export default PortalNav;
